import { render, staticRenderFns } from "./Leads.vue?vue&type=template&id=62162357"
import script from "./Leads.vue?vue&type=script&setup=true&lang=js"
export * from "./Leads.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports